/* tslint:disable */
/* eslint-disable */
/**
 * compass-pro
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { OrgUserOnAzure } from './OrgUserOnAzure';
import {
    OrgUserOnAzureFromJSON,
    OrgUserOnAzureFromJSONTyped,
    OrgUserOnAzureToJSON,
    OrgUserOnAzureToJSONTyped,
} from './OrgUserOnAzure';
import type { OrganizationOnAzure } from './OrganizationOnAzure';
import {
    OrganizationOnAzureFromJSON,
    OrganizationOnAzureFromJSONTyped,
    OrganizationOnAzureToJSON,
    OrganizationOnAzureToJSONTyped,
} from './OrganizationOnAzure';

/**
 * 
 * @export
 * @interface ApprovedUserToMove
 */
export interface ApprovedUserToMove {
    /**
     * 
     * @type {OrgUserOnAzure}
     * @memberof ApprovedUserToMove
     */
    user: OrgUserOnAzure;
    /**
     * 
     * @type {OrganizationOnAzure}
     * @memberof ApprovedUserToMove
     */
    old_organization: OrganizationOnAzure;
    /**
     * 
     * @type {OrganizationOnAzure}
     * @memberof ApprovedUserToMove
     */
    target_organization: OrganizationOnAzure;
    /**
     * 
     * @type {string}
     * @memberof ApprovedUserToMove
     */
    new_group_name: string;
    /**
     * 
     * @type {string}
     * @memberof ApprovedUserToMove
     */
    old_group_name: string;
    /**
     * 
     * @type {string}
     * @memberof ApprovedUserToMove
     */
    join_org_pin?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApprovedUserToMove
     */
    user_history_azure_id: string;
    /**
     * 
     * @type {string}
     * @memberof ApprovedUserToMove
     */
    user_private_settings_azure_id: string;
}

/**
 * Check if a given object implements the ApprovedUserToMove interface.
 */
export function instanceOfApprovedUserToMove(value: object): value is ApprovedUserToMove {
    if (!('user' in value) || value['user'] === undefined) return false;
    if (!('old_organization' in value) || value['old_organization'] === undefined) return false;
    if (!('target_organization' in value) || value['target_organization'] === undefined) return false;
    if (!('new_group_name' in value) || value['new_group_name'] === undefined) return false;
    if (!('old_group_name' in value) || value['old_group_name'] === undefined) return false;
    if (!('user_history_azure_id' in value) || value['user_history_azure_id'] === undefined) return false;
    if (!('user_private_settings_azure_id' in value) || value['user_private_settings_azure_id'] === undefined) return false;
    return true;
}

export function ApprovedUserToMoveFromJSON(json: any): ApprovedUserToMove {
    return ApprovedUserToMoveFromJSONTyped(json, false);
}

export function ApprovedUserToMoveFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApprovedUserToMove {
    if (json == null) {
        return json;
    }
    return {
        
        'user': OrgUserOnAzureFromJSON(json['user']),
        'old_organization': OrganizationOnAzureFromJSON(json['old_organization']),
        'target_organization': OrganizationOnAzureFromJSON(json['target_organization']),
        'new_group_name': json['new_group_name'],
        'old_group_name': json['old_group_name'],
        'join_org_pin': json['join_org_pin'] == null ? undefined : json['join_org_pin'],
        'user_history_azure_id': json['user_history_azure_id'],
        'user_private_settings_azure_id': json['user_private_settings_azure_id'],
    };
}

export function ApprovedUserToMoveToJSON(json: any): ApprovedUserToMove {
    return ApprovedUserToMoveToJSONTyped(json, false);
}

export function ApprovedUserToMoveToJSONTyped(value?: ApprovedUserToMove | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'user': OrgUserOnAzureToJSON(value['user']),
        'old_organization': OrganizationOnAzureToJSON(value['old_organization']),
        'target_organization': OrganizationOnAzureToJSON(value['target_organization']),
        'new_group_name': value['new_group_name'],
        'old_group_name': value['old_group_name'],
        'join_org_pin': value['join_org_pin'],
        'user_history_azure_id': value['user_history_azure_id'],
        'user_private_settings_azure_id': value['user_private_settings_azure_id'],
    };
}

